import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ActivityPackStatus, ActivityPackType, ActivityStatusType } from '../Modules/management/models/instance/activity-pacck-type.model';
import { AllowedItem } from '../Modules/settings/models/informate/allowed-item';
import { User } from '../Modules/management/models/organization/user.model';
import { FormGroup } from '@angular/forms';
import { InstanceModel } from '../Modules/management/models/instance/instance.model';

@Injectable({
    providedIn: 'root',
})
export class InstanceDataService {
    instanceDetails: InstanceModel;
    instanceDetails_New: InstanceModel;
    activityStatusTypes: ActivityStatusType[];
    activityStatusTypesList = new Subject<ActivityPackStatus[]>();
    navigateThroughWizard = new Subject<number>();
    currentInstanceId = new Subject<string>();
    currentInstanceType = new Subject<boolean>();
    currentInstanceName = new BehaviorSubject<string>(null);
    currentAssetType = new BehaviorSubject<string>(null);
    currentAssetTypeId = new BehaviorSubject<string>(null);
    selectedActivityPackTypes: ActivityPackType[];
    isInformateInstance = new BehaviorSubject<boolean>(null);
    defaultActivityPackSchema: string;
    defaultProjectTypeSchema: string;
    defaultTagItemSchema: string;
    activityPackTypeList = new Subject<ActivityPackType[]>();
    workflowStatusTypes: ActivityStatusType[];

    isDisableInstance = new Subject<boolean>();
    isDisableViewHirarchy = new Subject<boolean>();
    isDisableProjecttype = new Subject<boolean>();
    isDisableActivityPacks = new Subject<boolean>();
    isDisableActivityWorkflow = new Subject<boolean>();
    isDiableWorkpackReports = new Subject<boolean>();
    isDisbleInstanceUsers = new Subject<boolean>();
    isDisableInstanceInformate = new Subject<boolean>();
    isDisbleInstanceOthers = new Subject<boolean>();
    isDiableReports = new Subject<boolean>();
    isDisableTagPrinter = new Subject<boolean>();
    currentLayer = new BehaviorSubject<number>(null);
    currentLayerName = new BehaviorSubject<string>('Area');
    userDetails = new BehaviorSubject<User>(null);
    selectedAllowedItems = new BehaviorSubject<AllowedItem>(null);
    selectedBreadcrumbAllowedItems = new BehaviorSubject<string>(null);
    AllowedItemsselectAll = new BehaviorSubject<boolean>(null);
    instanceActiveTab = new Subject<string>();

    lineNumberFormArray: FormGroup[];
    jointIDForm: FormGroup;

    instanceTabNext = new Subject<string>();
    instanceTabBack = new Subject<string>();
    setActivityStatusType(statusTypes: ActivityStatusType[]) {
        this.activityStatusTypes = statusTypes;
    }

    getActivityStatusType() {
        return this.activityStatusTypes;
    }

    // * navigation handler for organization
    instanceNavigationHandler(index: number) {
        switch (index) {
            case 0: // * when istance Type ice in details tab
                this.navigateThroughWizard.next(1);
                this.isDisableInstance.next(true);
                this.isDisbleInstanceUsers.next(false); // * enable the user-typ tab

                break;
            case 1: // * when istance Type is other than ice  in detailstab
                this.navigateThroughWizard.next(1);
                this.isDisableInstance.next(true);
                this.isDisableViewHirarchy.next(false); // * enable the view hirarchy
                break;

            case 2: //when instance type informate in usertab next
                this.navigateThroughWizard.next(2);
                this.isDisbleInstanceUsers.next(true);
                this.isDisableInstanceInformate.next(false);
                break;
            case 3: //when instance type informate in usertab back
                this.navigateThroughWizard.next(0);
                this.isDisableInstance.next(false);
                this.isDisbleInstanceUsers.next(true);
                break;
            case 4: // when instance type informate - informate tab next
                this.navigateThroughWizard.next(2);
                this.isDisableInstanceInformate.next(false);
                this.isDisbleInstanceUsers.next(true);
                break;
            case 5: // when instance type informate - informate tab back
                this.navigateThroughWizard.next(1);
                this.isDisableInstanceInformate.next(true);
                this.isDisbleInstanceUsers.next(false);
                break;
            // when instance type is other than informate
            case 6: // in view hirarchy tab back
                this.navigateThroughWizard.next(0);
                this.isDisableInstance.next(false);
                this.isDisableViewHirarchy.next(true);
                break;

            case 7: // in view hirarchy tab next
                this.navigateThroughWizard.next(2);
                this.isDisableViewHirarchy.next(true);
                this.isDisableProjecttype.next(false);
                break;

            case 8: // in project type next
                this.navigateThroughWizard.next(3);
                this.isDisableActivityPacks.next(false);
                this.isDisableProjecttype.next(true);
                break;

            case 9: // in project type back
                this.navigateThroughWizard.next(1);
                this.isDisableViewHirarchy.next(false);
                this.isDisableProjecttype.next(true);
                break;

            case 10: // Activity Type next
                this.navigateThroughWizard.next(4);
                this.isDisableActivityPacks.next(true);
                this.isDisableActivityWorkflow.next(false);
                break;

            case 11: // Activity Type back
                this.navigateThroughWizard.next(2);
                this.isDisableActivityPacks.next(true);
                this.isDisableProjecttype.next(false);
                break;

            case 12: // Activity work flow next
                this.navigateThroughWizard.next(5);
                this.isDisableActivityWorkflow.next(true);
                this.isDiableReports.next(false);
                break;
            case 13: // Activity work flow back
                this.navigateThroughWizard.next(3);
                this.isDisableActivityWorkflow.next(true);
                this.isDisableActivityPacks.next(false);
                break;
            case 14: // Report next
                this.navigateThroughWizard.next(6);
                this.isDisbleInstanceUsers.next(false);
                this.isDiableReports.next(true);
                break;
            case 15: // Report back
                this.navigateThroughWizard.next(4);
                this.isDisableActivityWorkflow.next(false);
                this.isDiableReports.next(true);
                break;

            case 16: //user next
                this.navigateThroughWizard.next(7);
                this.isDisableInstanceInformate.next(false);
                this.isDisbleInstanceUsers.next(true);
                break;

            case 17: //user back
                this.navigateThroughWizard.next(5);
                this.isDisbleInstanceUsers.next(true);
                this.isDiableReports.next(false);
                break;

            case 18: //informae next
                this.navigateThroughWizard.next(8);
                this.isDisbleInstanceOthers.next(false);
                this.isDisableInstanceInformate.next(true);
                break;

            case 19: //informate back
                this.navigateThroughWizard.next(6);
                this.isDisbleInstanceUsers.next(false);
                this.isDisableInstanceInformate.next(true);
                break;

            case 20: //others back
                this.navigateThroughWizard.next(7);
                this.isDisbleInstanceOthers.next(true);
                this.isDisableInstanceInformate.next(false);
                break;

            case 21: //others mext
                this.navigateThroughWizard.next(9);
                this.isDisbleInstanceOthers.next(true);
                this.isDisableTagPrinter.next(false);
                break;

            case 22: //tag printing back
                this.navigateThroughWizard.next(8);
                this.isDisbleInstanceOthers.next(false);
                this.isDisableTagPrinter.next(true);
                break;
        }
    }

    // handleDisable() {
    //     return !(this.formGroupArray.every((item) => item.valid) && this.formGroupArray.some((x) => x.dirty)) || !this.jointIDForm?.valid;
    // }
}
